import type { RouteRecordRaw } from 'vue-router';

import { computed } from 'vue';

import { useGlobalI18n } from '@abaninja/util-i18n';

const { global: { t } } = useGlobalI18n();

export const routes: RouteRecordRaw[] = [
  {
    name: 'dashboard',
    path: '',
    component: () => import('../DashboardIndex.vue'),
    meta: {
      exact: true,
      needsAccount: true,
      title: computed(() => t('messages.dashboard')),
    },
  },
];
